// extracted by mini-css-extract-plugin
export default {"Grid":"style_Grid__5x0aW"};